
export default function(o, result, itemWidth, itemHeight){

  var imageUrl = o.util.getUrl('asset') + result.image

  var imageDiv = $('<img>')

  var click = function(){
    o.log('sponsorClick',result.link)
    open(result.link,'_blank')
  }

  var resize = function(w, h){
    itemWidth = w
    itemHeight = h
    imageDiv.attr({
      width: itemWidth,
      height: itemHeight,
    })
    div.css({
      width: `${itemWidth}px`,
      height: `${itemHeight}px`,
    })
  }

  var isActive = false

  var start = function(){

    if(isActive){ return }
    isActive = true

    imageDiv
    .attr({
      src: imageUrl,
      width: itemWidth,
      height: itemHeight,
      zIndex: 0,
    })
    .css({
      borderRight: '5px solid black',
      borderBottom: '5px solid black',
      position: 'absolute',
      top: 0,
      left: 0,
    })

    div
    .append([
      imageDiv,
    ])

  }

  var stop = function(){

    if(!isActive){ return }
    isActive = false

    div
    .empty()

  }

  var div =
    $('<div>')
    .css({
      borderRight: '5px solid black',
      borderBottom: '5px solid black',
      display: 'inline-flex',
      position: 'relative',
      backgroundColor: 'rgba(255,255,255,0.1)',
      width: `${itemWidth}px`,
      height: `${itemHeight}px`,
      alignItems: 'center',
      justifyContent: 'center',
      verticalAlign: 'top',
      lineHeight: '1.2em',
      cursor: 'pointer',
    })
    .click(click)

  div.start = start
  div.stop = stop
  div.resize = resize

  return div

}



// WEBPACK FOOTER //
// ./src/client/view/frontend/views/sponsors/grid/item/item.js